import { escapeRegExp } from '@lumapps/utils/string/escapeRegExp';

/**
 * Split text into segments around query matches.
 *
 * @param text - The text to match against
 * @param query - The string to match (case-insensitive)
 * @returns Array of segments with `{ index, str, matches }` where `matches` indicates a query match
 */
export function findMatchesInText(text: string, query: string) {
    if (!query) {
        return [{ index: 0, str: text, matches: false }];
    }

    try {
        const escapedQuery = escapeRegExp(query);
        const regex = new RegExp(`(${escapedQuery})`, 'i');
        return text
            .split(regex)
            .filter(Boolean)
            .map((str, i) => ({ index: i, str, matches: regex.test(str) }));
    } catch {
        // Defensive fallback: never throw, always return the text as a single non-matching segment.
        return [{ index: 0, str: text, matches: false }];
    }
}
